import { EXPERIMENTS } from '../../lib/feedContext';

/** Dedicated cash workspace; legacy book URLs remain readable. */
const base = (import.meta.env.BASE_URL || '/').replace(/\/+$/, '');
export const bookHref = (): string => `${EXPERIMENTS ? '' : base}/kassa`;
export const isBook = (pathname: string): boolean =>
  /\/(?:kassa|book)$/.test(pathname.replace(/\/+$/, ''));
